export const CREATE_WORK_ERROR_MESSAGE =
    'There is an error in your submission. Please review your submission and retry. If ' +
    'you continue to have issues, use the Contact Us form or call customer support.'
export const REQUIRED_MESSAGE = 'Required'
export const IS_NUMBER_MESSAGE = 'Value must contain only numbers'
export const MAX_LENGTH_MESSAGE = 'Invalid value, max length'
export const MIN_LENGTH_MESSAGE = 'Invalid value, min length'
export const STATIC_LENGTH_MESSAGE = 'Invalid value, length of value must be'
export const EMAIL_MESSAGE = 'Invalid email address'
export const NO_RESERVED_EMAIL_MESSAGE = 'This email domain is internal and can’t be used'
export const IS_DURATION_MESSAGE = 'Enter the duration in the format 00:00'
export const IS_LANGUAGE_MESSAGE = 'Please select language'
export const IS_DATE_MESSAGE = 'Enter the date in format YYYY-MM-DD'
export const IS_ISWC_MESSAGE =
    'The ISWC format must have a prefix letter, followed by 10 digits. Hyphens are optional. Example: T-034.524.680-1'
export const IS_IPI_MESSAGE = 'Invalid IPI number'
export const IS_US_POSTAL_CODE_MESSAGE = 'Invalid US postal code'
export const BIRTHDAY_ERROR_MESSAGE = 'Birthday must earlier than today'
export const FAILED_VERIFICATION_MESSAGE =
    'Your account has failed verification. Please contact support for more information.'
export const PUBLISHER_SHARE_IS_0_ERROR = 'Publisher share must be greater than 0'
export const NO_PAYEE_ACTIVITY =
    'Your payee activity is currently unavailable. Please contact The MLC Support Team for more information.'
export const IS_ISRC_MESSGAE =
    'ISRC must be alpha-numeric, 12 characters long, the first two characters must be letters, and the last 7 characters must be numbers'
